import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

const APIROOT = '//test.cfcity.cn/index.php/api/front';
const TIMEOUT = 7000;

export function jsonp(url, params) {
  return new Promise((resolve, reject) => {
    let _p = params || {};

    Vue.http.jsonp(APIROOT + url, {
      params: _p,
      jsonpCallback: params.callback,
      timeout: TIMEOUT,
    }).then(res => {
      resolve(res.body);
    }, err => {
      _hmt && _hmt.push(['_trackEvent', 'JSONP', APIROOT + url, JSON.stringify({ errorRes: err, data: _p })]);
      reject(err);
    });
  });
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    let _p = params || {};

    Vue.http.post(APIROOT + url, {
      params: _p,
      emulateJSON: true,
      responseTypee: 'json',
      timeout: TIMEOUT,
    }).then(res => {
      resolve(res);
    }, err => {
      _hmt && _hmt.push(['_trackEvent', 'POST', APIROOT + url, JSON.stringify({ errorRes: err, data: _p })]);
      reject(err);
    });

  });
}

export function get(url, params) {
  return new Promise((resolve, reject) => {
    let _p = params || {};

    Vue.http.get(APIROOT + url, {
      params: _p,
      timeout: TIMEOUT,
    }).then(res => {
      resolve(res);
    }, err => {
      _hmt && _hmt.push(['_trackEvent', 'GET', APIROOT + url, JSON.stringify({ errorRes: err, data: _p })]);
      reject(err);
    })
  });
}

export function getScript(src, func) {
  let _script = document.createElement('script');
  _script.async = 'async';
  _script.src = src;
  if (func) {
    _script.onload = func;
  }
  document.getElementsByTagName('head')[0].appendChild(_script);
}
